import React from 'react'
import getConfig from 'next/config'

import { style } from '../../../../components/Common/Index.style'
import Page from '../../../../components/Page/Page'
import PageHeader from '../../../../components/PageHeader/PageHeader'
import Content from '../../../../components/Content/Content'
import SectionTitle from '../../../../components/SectioinTitle'
import BackBtn from '../../../../components/Common/BackBtn'
import BreadCrumb from '../../../../components/Breadcrumbs/Breadcrumbs'

const { publicRuntimeConfig } = getConfig()
const basePath = publicRuntimeConfig.basePath

const pageTitle = '新潟の暮らす・働くをめぐるマガジン「くらはたずかん」 | 新潟県民だより'

const Home = () => {
  return (
    <Page title={pageTitle}>
      <PageHeader pageTitle="県からのお知らせ" />
      <SectionTitle sectionTitle="新潟の暮らす・働くをめぐるマガジン「くらはたずかん」" />
      <Content css={style.content}>
        <BreadCrumb
            lists={[
              {
                name: "HOME",
                path: "/"
              },
              {
                name: "2023冬号 No.161 目次",
                path: "/no161"
              },
              {
                name: "県からのお知らせ"
              }
            ]}
          />
        
        <h3 css={style.subTitle01}>「あなたはどうして新潟で暮らし、働くのか？」<br />現役大学生が、新潟の「人」を通して若者定着の秘けつを探る</h3>
        <p>大学生が県内で暮らす・働く人へ取材し、自分らしい視点で読み解いていく「くらはたずかん」。新潟を選んだ人のライフスタイルや新潟を選ぶに至る気持ちの変化等について、大学生たちの共感・疑問や考えを記事にしています。現在、noteにて公開中。ぜひご覧ください。</p>
        
        <div>
          <img
            src={`${basePath}/no161/img/2-4.png`}
            alt="くらはたずかん　新潟県 学生情報発信　検索"
            css={style.img(600)}
          />
        </div>
        
        
        <p>記事は
          <a
            href="https://note.com/kurahata_niigata/"
            target="_blank"
            rel="noreferrer"
          >
            <span>こちら</span>
          </a>
          から
        </p>
        
        <p>【問い合わせ】大学・私学振興課&emsp;電話：<a href="tel:025-280-5267">025-280-5267</a></p>

        <BackBtn href={"/no161"} />
      </Content>
    </Page>
  )
}
export default Home
